import merge from 'lodash/merge';
import legacyRecipeTheme from './legacyRecipeTheme';

export default merge(legacyRecipeTheme.recipeSpacing, {
  xxxsmall: '0.125em',
  xxsmall: '0.25em',
  xsmall: '0.5em',
  small: '0.75em',
  normal: '1em',
  medium: '1.25em',
  big: '1.5em',
  large: '2em',
  xlarge: '3em',
});
